export const PROMPTS_PANEL_MODES = {
  HIDDEN: "HIDDEN",
  SHARING: "SHARING",
  DISPLAY_CONTEXT: "DISPLAY_CONTEXT",
};
